import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { ResetarSenhaComponent } from './resetar-senha/resetar-senha.component';
import { EsqueceuSenhaComponent } from './esqueceu-senha/esqueceu-senha.component';
import { LoginGIComponent } from './login-gi/login-gi.component';
import { TipoDeLogin } from './models/enum';
import { CadastroComponent } from './cadastro/cadastro.component';
import { TestesComponent } from './testes/testes.component';
import { RastreioExternoComponent } from './rastreio-externo/rastreio-externo.component';
import { LogoutComponent } from './logout/logout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginGIComponent,
    data: {
      title: 'Login',
      tipo: TipoDeLogin.Integrador,
    },
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      title: 'Logout',
    },
  },
  {
    path: 'cadastro',
    component: CadastroComponent,
    data: {
      title: 'Cadastro de Integrador',
    },
  },
  {
    path: 'testes',
    component: TestesComponent,
  },
  {
    path: 'esqueceu-senha',
    component: EsqueceuSenhaComponent,
    data: {
      title: 'Recuperar Acesso',
    },
  },
  {
    path: 'resetar-senha/:token/:idusuario',
    component: ResetarSenhaComponent,
    data: {
      title: 'Recuperar Acesso',
    },
  },
  {
    path: 'rastreio-externo/:token',
    component: RastreioExternoComponent,
    data: {
      title: 'Rastreio do Pedido',
    },
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'pages',
        loadChildren: './pages/pages.module#PagesModule',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
